import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { AwardsRoutes } from "./awards.routes";
import { AwardListComponent } from "./award-list/award-list.component";
import { AwardFormComponent } from "./award-form/award-form.component";
import { AwardService, AwardFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    AwardsRoutes,
  ],
  declarations: [AwardListComponent, AwardFormComponent],
  providers: [AwardService, AwardFormService],
})
export class AwardsModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/awards/awards.module.ts